import { useState, useEffect } from 'react';
import _ from 'lodash';

const findScreenSize = ({ width }) => {
  if (width < 576) return 'xs';
  if (width >= 1600) return 'xxl';
  if (width >= 1200) return 'xl';
  if (width >= 992) return 'lg';
  if (width >= 768) return 'md';
  if (width >= 576) return 'sm';
};

function getWindowDimensions(props) {
  const { innerWidth, innerHeight } = window;
  const { userAgent } = navigator;
  const isIPad = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Phone/i.test(userAgent);
  const width = props?.customWidth || innerWidth;
  const height = props?.customHeight || innerHeight;

  return {
    width,
    height,
    isMobile: isMobileDevice || isIPad || width < 767,
    allowedEditing: width >= 360,
    screenSize: findScreenSize({ width }),
  };
}

export default function useWindowDimensions(props) {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions(props));

  useEffect(() => {
    const debouncedResizeHandler = _.debounce(() => {
      setWindowDimensions(getWindowDimensions());
    }, 100); // 100ms

    window.addEventListener('resize', debouncedResizeHandler);
    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, []);

  return windowDimensions;
}
